import React from "react";
import { Form, Button } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { InputItem } from "../../../components/forms/FormItems";
import { useIntl } from "react-intl";

const LoginForm = ({
  onFinish,
  onFinishFailed,
  onValuesChange,
  loading,
  authError,
  recaptchaRef,
}) => {
  const intl = useIntl();

  return (
    <Form
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onValuesChange={onValuesChange}
    >
      <InputItem
        name="username"
        category="user"
        required={true}
        hideLabel={true}
        placeholder={intl.formatMessage({
          id: "app.forms.user.username",
        })}
        prefix={<UserOutlined />}
      />
      <InputItem
        name="password"
        category="user"
        required={true}
        hideLabel={true}
        password={true}
        placeholder={intl.formatMessage({
          id: "app.forms.user.password",
        })}
        prefix={<LockOutlined />}
      />
      {authError ? (
        <p
          style={{
            margin: "-20px 0 20px ",
            width: "300px",
            color: "red",
          }}
        >
          {intl.formatMessage({
            id: `app.notifications.${authError}`,
            defaultMessage: authError,
          })}
        </p>
      ) : null}
      <Form.Item>
        <div ref={recaptchaRef} id="sign-in-button" />
        <Button loading={loading} block type="primary" htmlType="submit">
          {intl.formatMessage({
            id: "app.actions.connect",
          })}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default LoginForm;
